import { Failure } from '@bringg-frontend/batch-action-status';
import { makeObservable, action, computed, observable } from 'mobx';
import { AsyncOperationStore } from '@bringg-frontend/global-stores';

/**
 * Centralized store for managing multiple async operations
 * This store keeps track of all new active async operations and provides
 * methods to add and remove operations
 */
export class AsyncNotificationStore {
	operationsMap = new Map<string, AsyncOperationStore<Failure<boolean>>>();

	constructor() {
		makeObservable(this, {
			operationsMap: observable,
			operations: computed,
			addOperation: action,
			removeOperation: action,
			dispose: action
		});
	}

	get operations(): AsyncOperationStore<Failure<boolean>>[] {
		return Array.from(this.operationsMap.values());
	}

	addOperation(operation: AsyncOperationStore<Failure<boolean>>) {
		this.operationsMap.set(operation.id, operation);
	}

	removeOperation(operationId: string) {
		this.operationsMap.delete(operationId);
	}

	dispose() {
		this.operationsMap.clear();
	}
}

export const asyncNotificationStore = new AsyncNotificationStore();
